import { render, staticRenderFns } from "./configUserDataDialog.vue?vue&type=template&id=3fc9e25a&"
import script from "./configUserDataDialog.vue?vue&type=script&lang=js&"
export * from "./configUserDataDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports